import { Heading } from "@ariakit/react";
import classNames from "clsx";

import type { ListView } from "../../../types/webTypes";
import type { FeedItems } from "../../../types/content/feedItem";
import type { SponsoredBannerData } from "../../../types/ads/sponsoredBanner";

import { CategoryArticlesList } from "./CategoryArticlesList/CategoryArticlesList";
import { TopicArticlesList } from "./TopicArticlesList/TopicArticlesList";
import styles from "../Feed.module.scss";
import { isInjectable } from "../../../utils/typechecks";
import { SponsoredBanner } from "../../SponsoredBanner/SponsoredBanner";

const ListLayout = ({
  data,
  listView,
  isFirstFeed,
  sponsoredBannerData,
  endOfFeed,
  headerTitle,
}: {
  data: FeedItems;
  listView: ListView;
  isFirstFeed?: boolean;
  sponsoredBannerData?: SponsoredBannerData | null;
  endOfFeed?: boolean;
  headerTitle?: string;
}) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <div className={listView === "category" ? styles.feed : ""}>
      {isFirstFeed && headerTitle && (
        <div
          className={classNames([
            styles.listHeader,
            listView === "topic" && styles.listHeaderSmall,
          ])}
        >
          <Heading className={styles.listTitle}>{headerTitle}</Heading>
        </div>
      )}
      {isFirstFeed && sponsoredBannerData && (
        <SponsoredBanner data={sponsoredBannerData} />
      )}
      {data.map((feedItem, clusterIndex) => {
        if (!feedItem || isInjectable(feedItem)) return null;

        if (listView === "topic") {
          const isFirstElement = clusterIndex === 0;
          const shouldPrioritizeImageLoad = clusterIndex > 3;
          return (
            <TopicArticlesList
              feedItem={feedItem}
              shouldPrioritizeImageLoad={shouldPrioritizeImageLoad}
              isFirstElement={isFirstElement}
              key={`${feedItem.id}${clusterIndex}`}
              endOfFeed={endOfFeed && clusterIndex === data.length - 1}
              positionInFeed={clusterIndex + 1}
            />
          );
        }

        if (listView === "category") {
          return (
            <CategoryArticlesList
              feedItem={feedItem}
              positionInFeed={clusterIndex + 1}
              key={`${feedItem.id}${clusterIndex}`}
            />
          );
        }

        return null;
      })}
    </div>
  );
};

export { ListLayout };
